import type { RouteLocationNormalized } from 'vue-router'

const RECOVERY_TARGET_KEY = 'proficontrol:chunk-load-recovery-target'

type RecoveryLocation = Pick<Location, 'assign'>
type RecoveryStorage = Pick<Storage, 'getItem' | 'setItem' | 'removeItem'>

export function isChunkLoadError(error: unknown): boolean {
  if (!(error instanceof Error)) {
    return false
  }

  return (
    error.name === 'ChunkLoadError' ||
    error.message.includes('Failed to fetch dynamically imported module') ||
    error.message.includes('Importing a module script failed') ||
    error.message.includes('error loading dynamically imported module') ||
    error.message.includes('Unable to preload CSS')
  )
}

export function recoverFromChunkLoadError(
  error: unknown,
  to: RouteLocationNormalized,
  location: RecoveryLocation = window.location,
  storage: RecoveryStorage = window.sessionStorage,
): boolean {
  if (!isChunkLoadError(error)) {
    return false
  }

  try {
    if (storage.getItem(RECOVERY_TARGET_KEY) === to.fullPath) {
      return false
    }

    storage.setItem(RECOVERY_TARGET_KEY, to.fullPath)
  } catch {
    // Storage can be unavailable in privacy-restricted browser contexts.
  }

  location.assign(to.fullPath)
  return true
}

export function clearChunkLoadRecovery(
  storage: RecoveryStorage = window.sessionStorage,
): void {
  try {
    storage.removeItem(RECOVERY_TARGET_KEY)
  } catch {
    // Storage can be unavailable in privacy-restricted browser contexts.
  }
}
